<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="$t('text.txt33')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  :pulling-text="$t('msg.下拉即可刷新')"  :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')">
          <van-empty v-if="list.length === 0" :description="$t('msg.没有数据')" />
          <div v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div class="topInfo">
              <span v-if="v.status === 2" style="color: #07c160">{{ names(v.status_text) }}</span>
              <span v-else >{{ names(v.status_text) }}</span>
              <span>{{ $t('msg.金额') }}：-{{v.money}}</span>
            </div>
            <div class="desc">
              <span>{{ $t('withdrawRecord.desc') }}：{{v.desc}}</span>
            </div>
            <div class="time">
              <span>{{ $t('withdrawRecord.create') }}：{{v.create_time}}</span>
            </div>
            <div class="time">
              <span>{{ $t('withdrawRecord.update') }}：{{ names(v.update_time_text) }}</span>
            </div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    names(name){
      if(name == "待审核"){
          return this.$t("msg.待审核");
      }else if(name == "审核成功"){
        return this.$t("msg.审核成功");
      }else if(name == "审核退回"){
        return this.$t("msg.审核退回");
      }
      return name;
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("msg.刷新成功！"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 18PX;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 18PX;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10PX;
}

.item_list{
  padding: 7PX;
  margin: 15PX 5PX;
  background: #fff;
  border-radius: 5PX;
  line-height: 30PX;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 18PX;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 16PX;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 16PX;
  font-weight: 700;
  color: #9b9b9b;
}

</style>
